module.exports = __webpack_public_path__ + "img/7_157.83e4c6a1.png";